import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Form } from "react-bootstrap";
import AvatarFilter from "../Common/AvatarFilter";
import { setCrewSelectedPlanType, setSelectedCrews, setIncludeEndedCrew, saveUserConfiguration } from "../../../actions/dashboard";

const CrewHeader = () => {
  const dispatch = useDispatch();
  const crewListById = useSelector((state) => state.dashboard.crew.crewListById.filteredPayload);
  const selectedCrewIds = useSelector((state) => state.dashboard.crew.selectedCrewIds);
  const includeEndedCrew = useSelector((state) => state.dashboard.crew.includeEndedCrew);
  const planTypeList = useSelector((state) => state.dashboard.planTypeList.payload);
  const selectedPlanTypeIds = useSelector((state) => state.dashboard.crew.selectedPlanTypeIds);
  const isAllPlan = useSelector((state) => state.plan.isSelectAllPlan);
  const farmId = useSelector((state) => state.farm.currentFarm.farm_uuid);
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);
  const userRemember = useSelector((state) => state.dashboard.userRemember.payload);
  const crewList = Object.keys(crewListById).map((id) => crewListById[id]);
  let crewListPlanType = [];

  crewList.forEach((item) => {
    if (crewListPlanType.indexOf(item.plan_type_id) >= 0) return;
    else crewListPlanType.push(item.plan_type_id);
  });

  const plantedCrewIds = useMemo(() => {
    return crewList.filter((each) => each.plan_type_id === selectedPlanType).map((e) => e.crew_uuid);
  }, [selectedPlanType, crewList]);

  const handlePlanType = (item) => {
    const list = [];
    list.indexOf(item) >= 0 ? list.splice(list.indexOf(item), 1) : list.push(item);

    dispatch(setCrewSelectedPlanType(list));
  };

  const handleCrewSelection = (event) => {
    const crewArray = event && event.value ? [...selectedCrewIds, event.value] : [...selectedCrewIds];
    const finalSelectedCrewList = crewArray
      .filter((e) => plantedCrewIds.includes(e))
      .map((each, index) => {
        return { id: each, display_order: index + 1 };
      });
    let filterCrewRememberNotInPlanTypeId = [];
    if (userRemember && userRemember.crews && userRemember.crews.length > 0) {
      userRemember.crews.forEach((each) => {
        if (!crewListById[each.id]) {
          filterCrewRememberNotInPlanTypeId.push(each);
        }
      });
    }
    let finalCrewToRemember = filterCrewRememberNotInPlanTypeId && filterCrewRememberNotInPlanTypeId.length > 0 ? filterCrewRememberNotInPlanTypeId.concat(finalSelectedCrewList) : finalSelectedCrewList;
    const addCrewListConfiguration = {
      farm_uuid: farmId,
      configuration: {
        remember: {
          ...userRemember,
          crews: finalCrewToRemember,
        },
      },
    };
    dispatch(saveUserConfiguration(addCrewListConfiguration));

    if (event) dispatch(setSelectedCrews([...selectedCrewIds, event.value]));
  };

  const filteredPlanTypeList = planTypeList.filter((item) => crewListPlanType.indexOf(item.plan_type_id) >= 0);

  const options = crewList
    .filter((e) => selectedCrewIds.indexOf(e.crew_uuid) < 0 && (e.plan_type_id === 0 || selectedPlanTypeIds.indexOf(e.plan_type_id) >= 0))
    .map((item, i) => ({
      value: item.crew_uuid,
      label: item.crew_name,
      ...(item.is_end_crew && { color: "red" }),
    }));

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.data.color,
    }),
  };

  return (
    <Row className="crew-body-header">
      <Col lg={3} md={3} sm={3}>
        <Form.Group className="select-input mb-0">
          <Form.Select options={options} styles={customStyles} onChange={handleCrewSelection} placeholder={<div>Search</div>} value={""}></Form.Select>
        </Form.Group>
      </Col>
      <Col lg={3} md={3} sm={3} className="crew-check-box">
        <Form.Group title={includeEndedCrew ? "Exclude ended crews" : "Include ended crews"}>
          <Form.Check id="include-ended-crew" type="checkbox" label="Include ended crews" onChange={(e) => dispatch(setIncludeEndedCrew(e.target.checked))} />
        </Form.Group>
      </Col>
      {isAllPlan && (
        <Col className="avatar-item">
          <AvatarFilter activePlanType={selectedPlanTypeIds} handlePlanType={handlePlanType} planTypeList={filteredPlanTypeList} />
        </Col>
      )}
    </Row>
  );
};

export default CrewHeader;
